import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import Admin from "./pages/admin/Admin";
import { socket } from './socket';
import { ConnectionState } from './socket/ConnectionState';
import { ConnectionManager } from './socket/ConnectionManager';
import Notifier from "react-desktop-notification"

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { Component, useContext, useEffect, useState } from "react";
import { AuthContext } from "./context/AuthContext";
import Status from "./pages/status/Status";

function App() {
  const { user, socketio } = useContext(AuthContext);
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [fooEvents, setFooEvents] = useState([]);
  const [selectedMission, setSelectedMission] = useState(null);
  
  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
      console.log("Connected");
    }

    function onDisconnect() {
      setIsConnected(false);
      console.log("Disconnected");
    }

    function onFooEvent(value) {
      setFooEvents(previos => [...previos, value]);
    }

    function onNewMission() {
      Notifier.start("Neuer Einsatz eingegangen", "Inhalttext", "", "", "");
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("foo", onFooEvent);
    socket.on("newMission", onNewMission);
  
    return() => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("foo", onFooEvent);
      socket.off("newMission", onNewMission);
    }
  });


  return (
    <div className="App">
      {/* <ConnectionState isConnected={ isConnected } /> */}
      <Router>
        <Routes>
          <Route path="/" 
            element={user ? <Home 
            socketio={socket} 
            connectionState={isConnected} 
            selectedMission={selectedMission}
            setSelectedMission={setSelectedMission} /> : <Login />}
          />
          <Route path="/login" element={user ? <Navigate replace to="/" /> : <Login />}/>
          <Route path="/admin" element={user ? <Admin 
          socketio={socket}
          connectionState={isConnected} /> : <Login />}/>
          <Route path="/status" element={user ? <Status 
          socketio={socket}
          connectionState={isConnected} /> : <Login />}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;